import { TriangleAlert } from 'lucide-react';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

export interface ModelChangeChoiceProps {
  /** Name of the model production uses today. */
  currentModelName: string;
  /** Name of the model saved on the version. */
  versionModelName: string;
  applyModel: boolean;
  onApplyModelChange: (applyModel: boolean) => void;
  /** Master versions with subprojects: applying the model also moves every subproject. */
  movesSubprojects?: boolean;
}

/** Shown when a version goes to production with a model different from the one production uses. */
const ModelChangeChoice = ({
  currentModelName,
  versionModelName,
  applyModel,
  onApplyModelChange,
  movesSubprojects = false,
}: ModelChangeChoiceProps): JSX.Element => (
  <Alert>
    <TriangleAlert />
    <AlertTitle>Esta versión usa otro modelo</AlertTitle>
    <AlertDescription className="flex flex-col gap-3 text-xs">
      <span>
        Producción usa <strong>{currentModelName}</strong> y esta versión usa <strong>{versionModelName}</strong>. Elige
        qué modelo usará el agente con los clientes reales.
      </span>
      <RadioGroup
        value={applyModel ? 'apply' : 'keep'}
        onValueChange={(value) => onApplyModelChange(value === 'apply')}
        className="gap-2"
      >
        <Label htmlFor="model-choice-keep" className="flex items-center gap-2 text-xs font-normal">
          <RadioGroupItem value="keep" id="model-choice-keep" />
          Mantener {currentModelName}
        </Label>
        <Label htmlFor="model-choice-apply" className="flex items-center gap-2 text-xs font-normal">
          <RadioGroupItem value="apply" id="model-choice-apply" />
          Cambiar a {versionModelName}
        </Label>
      </RadioGroup>
      {applyModel && movesSubprojects && <span>Los subproyectos también pasan a este modelo.</span>}
    </AlertDescription>
  </Alert>
);

export default ModelChangeChoice;
